import React from 'react';

/**
 * Reusable metric card component
 */
export const MetricCard = ({ value, label, subtitle, color = 'emerald' }) => {
  const colorClasses = {
    emerald: {
      bg: 'bg-emerald-50 dark:bg-emerald-900/30',
      border: 'border-emerald-200 dark:border-emerald-700',
      valueColor: 'text-emerald-600 dark:text-emerald-400',
      labelColor: 'text-emerald-800 dark:text-emerald-300'
    },
    blue: {
      bg: 'bg-blue-50 dark:bg-blue-900/30',
      border: 'border-blue-200 dark:border-blue-700',
      valueColor: 'text-blue-600 dark:text-blue-400',
      labelColor: 'text-blue-800 dark:text-blue-300'
    },
    purple: {
      bg: 'bg-purple-50 dark:bg-purple-900/30',
      border: 'border-purple-200 dark:border-purple-700',
      valueColor: 'text-purple-600 dark:text-purple-400',
      labelColor: 'text-purple-800 dark:text-purple-300'
    }
  };

  const classes = colorClasses[color] || colorClasses.emerald;

  return (
    <div className={`${classes.bg} ${classes.border} rounded-xl p-6 border`}>
      <div className={`text-3xl font-bold ${classes.valueColor} mb-2`}>
        {value}
      </div>
      <div className={`${classes.labelColor} font-medium`}>{label}</div>
      {subtitle && (
        <div className={`text-sm ${classes.valueColor} mt-1`}>{subtitle}</div>
      )}
    </div>
  );
};

